(function($) {
    /*


      Copyright 2012 Google Inc.
     
      Licensed under the Apache License, Version 2.0 (the "License");
      you may not use this file except in compliance with the License.
      You may obtain a copy of the License at
     
          http://www.apache.org/licenses/LICENSE-2.0
     
      Unless required by applicable law or agreed to in writing, software
      distributed under the License is distributed on an "AS IS" BASIS,
      WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      See the License for the specific language governing permissions and
      limitations under the License.
     */
    var storeLocator = function() {};
    window.storeLocator = storeLocator;
    storeLocator.toRad_ = function(a) {
        return a * Math.PI / 180
    };
    storeLocator.Feature = function(a, b) {
        this.id_ = a;
        this.name_ = b
    };
    storeLocator.Feature = storeLocator.Feature;
    storeLocator.Feature.prototype.getId = function() {
        return this.id_
    };
    storeLocator.Feature.prototype.getDisplayName = function() {
        return this.name_
    };
    storeLocator.Feature.prototype.toString = function() {
        return this.getDisplayName()
    };
    storeLocator.FeatureSet = function(a) {
        this.array_ = [];
        this.hash_ = {};
        for (var b = 0, c; c = arguments[b]; b++) this.add(c)
    };
    storeLocator.FeatureSet = storeLocator.FeatureSet;
    storeLocator.FeatureSet.prototype.toggle = function(a) {
        this.contains(a) ? this.remove(a) : this.add(a)
    };
    storeLocator.FeatureSet.prototype.contains = function(a) {
        return a.getId() in this.hash_
    };
    storeLocator.FeatureSet.prototype.getById = function(a) {
        return a in this.hash_ ? this.array_[this.hash_[a]] : null
    };
    storeLocator.FeatureSet.prototype.add = function(a) {
        a && (this.array_.push(a), this.hash_[a.getId()] = this.array_.length - 1)
    };
    storeLocator.FeatureSet.prototype.remove = function(a) {
        this.contains(a) && (this.array_[this.hash_[a.getId()]] = null, delete this.hash_[a.getId()])
    };
    storeLocator.FeatureSet.prototype.asList = function() {
        for (var a = [], b = 0, c = this.array_.length; b < c; b++) {
            var d = this.array_[b];
            null !== d && a.push(d)
        }
        return a
    };
    storeLocator.FeatureSet.NONE = new storeLocator.FeatureSet;
    storeLocator.GMEDataFeed = function(a) {
        this.tableId_ = a.tableId;
        this.apiKey_ = a.apiKey;
        a.propertiesModifier && (this.propertiesModifier_ = a.propertiesModifier)
    };
    storeLocator.GMEDataFeed = storeLocator.GMEDataFeed;
    storeLocator.GMEDataFeed.prototype.getStores = function(a, b, c) {
        var d = this,
            e = a.getCenter();
        a = "(ST_INTERSECTS(geometry, " + this.boundsToWkt_(a) + ") OR ST_DISTANCE(geometry, " + this.latLngToWkt_(e) + ") \x3c 20000)";
        $.getJSON("https://www.googleapis.com/mapsengine/v1/tables/" + this.tableId_ + "/features?callback\x3d?", {
            key: this.apiKey_,
            where: a,
            version: "published",
            maxResults: 300
        }, function(a) {
            a = d.parse_(a);
            d.sortByDistance_(e, a);
            c(a)
        })
    };
    storeLocator.GMEDataFeed.prototype.latLngToWkt_ = function(a) {
        return "ST_POINT(" + a.lng() + ", " + a.lat() + ")"
    };
    storeLocator.GMEDataFeed.prototype.boundsToWkt_ = function(a) {
        var b = a.getNorthEast();
        a = a.getSouthWest();
        return ["ST_GEOMFROMTEXT('POLYGON ((", a.lng(), " ", a.lat(), ", ", b.lng(), " ", a.lat(), ", ", b.lng(), " ", b.lat(), ", ", a.lng(), " ", b.lat(), ", ", a.lng(), " ", a.lat(), "))')"].join("")
    };
    storeLocator.GMEDataFeed.prototype.parse_ = function(a) {
        if (a.error) return window.alert(a.error.message), [];
        a = a.features;
        if (!a) return [];
        for (var b = [], c = 0, d; d = a[c]; c++) {
            var e = d.geometry.coordinates,
                e = new google.maps.LatLng(e[1], e[0]);
            d = this.propertiesModifier_(d.properties);
            d = new storeLocator.Store(d.id, e, null, d);
            b.push(d)
        }
        return b
    };
    storeLocator.GMEDataFeed.prototype.propertiesModifier_ = function(a) {
        return a
    };
    storeLocator.GMEDataFeed.prototype.sortByDistance_ = function(a, b) {
        b.sort(function(b, d) {
            return b.distanceTo(a) - d.distanceTo(a)
        })
    };
    storeLocator.GMEDataFeedOptions = function() {};
    storeLocator.Panel = function(a, b) {
        this.el_ = $(a);
        this.el_.addClass("storelocator-panel");
        this.settings_ = $.extend({
            locationSearch: !0,
            locationSearchLabel: "Where are you?",
            featureFilter: !0,
            directions: !0,
            view: null
        }, b);
        this.directionsRenderer_ = new google.maps.DirectionsRenderer({
            draggable: !0
        });
        this.directionsService_ = new google.maps.DirectionsService;
        this.init_()
    };
    storeLocator.Panel = storeLocator.Panel;
    storeLocator.Panel.prototype = new google.maps.MVCObject;
    storeLocator.Panel.prototype.init_ = function() {
        var a = this;
        this.itemCache_ = {};
        this.settings_.view && this.set("view", this.settings_.view);
        this.filter_ = $('\x3cform class\x3d"storelocator-filter"/\x3e');
        this.el_.append(this.filter_);
        this.settings_.locationSearch && (this.locationSearch_ = $('\x3cdiv class\x3d"location-search"\x3e\x3ch4\x3e' + this.settings_.locationSearchLabel + "\x3c/h4\x3e\x3cinput\x3e\x3c/div\x3e"), this.filter_.append(this.locationSearch_), "undefined" != typeof google.maps.places ? this.initAutocomplete_() :
            this.filter_.submit(function() {
                var b = $("input", a.locationSearch_).val();
                a.searchPosition(b)
            }), this.filter_.submit(function() {
                return !1
            }), google.maps.event.addListener(this, "geocode", function(b) {
                if (b.geometry) {
                    this.directionsFrom_ = b.geometry.location;
                    a.directionsVisible_ && a.renderDirections_();
                    var c = a.get("view");
                    c.highlight(null);
                    var d = c.getMap();
                    d.setCenter(b.geometry.location), d.setZoom(8); // zoom after location search
                    c.refreshView();
                    a.listenForStoresUpdate_()
                } else a.searchPosition(b.name)
            }));
        if (this.settings_.featureFilter) {
            this.featureFilter_ = $('\x3cdiv class\x3d"feature-filter"/\x3e');
            for (var b = this.get("view").getFeatures().asList(), c = 0, d = b.length; c < d; c++) {
                var e = b[c],
                    f = $('\x3cinput type\x3d"checkbox"/\x3e');
                f.data("feature", e);
                $("\x3clabel/\x3e").append(f).append(e.getDisplayName()).appendTo(this.featureFilter_)
            }
            this.filter_.append(this.featureFilter_);
            this.featureFilter_.find("input").change(function() {
                var b = $(this).data("feature");
                a.toggleFeatureFilter_(b);
                a.get("view").refreshView()
            })
        }
        this.storeList_ =
            $('\x3cul class\x3d"store-list"/\x3e');
        document.querySelector('.search-loc').append(document.querySelector('.storelocator-filter'));
        this.el_.append(this.storeList_);
        this.settings_.directions && (this.directionsPanel_ = $('\x3cdiv class\x3d"directions-panel"\x3e\x3cform\x3e\x3cinput class\x3d"directions-to"/\x3e\x3cinput type\x3d"submit" value\x3d"Find directions"/\x3e\x3ca href\x3d"#" class\x3d"close-directions"\x3eClose\x3c/a\x3e\x3c/form\x3e\x3cdiv class\x3d"rendered-directions"\x3e\x3c/div\x3e\x3c/div\x3e'), this.directionsPanel_.find(".directions-to").attr("readonly", "readonly"), this.directionsPanel_.hide(),
            this.directionsVisible_ = !1, this.directionsPanel_.find("form").submit(function() {
                a.renderDirections_();
                return !1
            }), this.directionsPanel_.find(".close-directions").click(function() {
                a.hideDirections()
            }), this.el_.append(this.directionsPanel_))
    };
    storeLocator.Panel.prototype.toggleFeatureFilter_ = function(a) {
        var b = this.get("featureFilter");
        b.toggle(a);
        this.set("featureFilter", b)
    };
    storeLocator.geocoder_ = new google.maps.Geocoder;
    storeLocator.Panel.prototype.listenForStoresUpdate_ = function() {
        console.log('listenForStoresUpdate_??');
        var a = this,
            b = this.get("view");
        this.storesChangedListener_ && google.maps.event.removeListener(this.storesChangedListener_);
        this.storesChangedListener_ = google.maps.event.addListenerOnce(b, "stores_changed", function() {
            a.set("stores", b.get("stores"));
            console.log('storesChangedListener_??');
            console.log({
                a
            }, {
                b
            });
        })
    };
    storeLocator.Panel.prototype.searchPosition = function(a) {
        var b = this;
        a = {
            address: a,
            bounds: this.get("view").getMap().getBounds()
        };
        storeLocator.geocoder_.geocode(a, function(a, d) {
            d == google.maps.GeocoderStatus.OK && google.maps.event.trigger(b, "geocode", a[0])
        })
    };
    storeLocator.Panel.prototype.setView = function(a) {
        this.set("view", a)
    };
    storeLocator.Panel.prototype.view_changed = function() {
        var a = this.get("view");
        this.bindTo("selectedStore", a);
        var b = this;
        this.geolocationListener_ && google.maps.event.removeListener(this.geolocationListener_);
        this.zoomListener_ && google.maps.event.removeListener(this.zoomListener_);
        this.idleListener_ && google.maps.event.removeListener(this.idleListener_);
        a.getMap().getCenter();
        var c = function() {
            a.clearMarkers();
            b.listenForStoresUpdate_()
        };
        this.geolocationListener_ = google.maps.event.addListener(a, "load",
            c);
        this.zoomListener_ = google.maps.event.addListener(a.getMap(), "zoom_changed", c);
        this.idleListener_ = google.maps.event.addListener(a.getMap(), "idle", function() {
            return b.idle_(a.getMap())
        });
        c();
        this.bindTo("featureFilter", a);
        this.autoComplete_ && this.autoComplete_.bindTo("bounds", a.getMap())
    };
    storeLocator.Panel.prototype.initAutocomplete_ = function() {
        var a = this,
            b = $("input", this.locationSearch_)[0];
        this.autoComplete_ = new google.maps.places.Autocomplete(b);
        this.get("view") && this.autoComplete_.bindTo("bounds", this.get("view").getMap());
        google.maps.event.addListener(this.autoComplete_, "place_changed", function() {
            google.maps.event.trigger(a, "geocode", this.getPlace())
        })
    };
    storeLocator.Panel.prototype.idle_ = function(a) {
        this.center_ ? a.getBounds().contains(this.center_) || (this.center_ = a.getCenter(), this.listenForStoresUpdate_()) : this.center_ = a.getCenter()
    };
    // storeLocator.Panel.LOC_DETECTED_HTML_ = '\x3cli class\x3d"no-stores"\x3e' + locationSearchNote + '\x3c/li\x3e';
    storeLocator.Panel.LOC_DETECTED_HTML_ = `<li class="no-stores">${locationSearchNote}</li>`;
    storeLocator.Panel.NO_STORES_HTML_ = '\x3cli class\x3d"no-stores"\x3eThere are no stores in this area.\x3c/li\x3e';
    // storeLocator.Panel.NO_STORES_IN_VIEW_HTML_ = '\x3cli class\x3d"no-stores"\x3e' + locationNoStoreNote + '\x3c/li\x3e';
    storeLocator.Panel.NO_STORES_IN_VIEW_HTML_ = `<li class="no-stores">${locationNoStoreNote}</li>`;
    storeLocator.Panel.prototype.stores_changed = function() {
        if (this.get("stores")) {
            var a = this.get("view"),
                b = a && a.getMap().getBounds(),
                c = this.get("stores"),
                d = this.get("selectedStore");
            this.storeList_.empty();

            c.length ? b && !b.contains(c[0].getLocation()) && this.storeList_.append(storeLocator.Panel.NO_STORES_IN_VIEW_HTML_) : this.storeList_.append(storeLocator.Panel.NO_STORES_HTML_);

            // show location detected note if location is enabled and when not using location search
            if( c.length && this.filter_[0][0].value == '' ){
                this.storeList_.prepend(storeLocator.Panel.LOC_DETECTED_HTML_);
            }

            for (var b = function() {
                    a.highlight(this.store, !0)
                }, e = 0, f = Math.min(50, c.length); e < f; e++) {
                var g = c[e].getInfoPanelItem();
                g.store = c[e];
                d && c[e].getId() == d.getId() && $(g).addClass("highlighted");
                g.clickHandler_ || (g.clickHandler_ = google.maps.event.addDomListener(g, "click", b));
                this.storeList_.append(g)
            }
        }
    };
    storeLocator.Panel.prototype.selectedStore_changed = function() {
        $(".highlighted", this.storeList_).removeClass("highlighted");
        var a = this,
            b = this.get("selectedStore");
        if (b) {
            this.directionsTo_ = b;
            this.storeList_.find("#store-" + b.getId()).addClass("highlighted");
            this.settings_.directions && this.directionsPanel_.find(".directions-to").val(b.getDetails().title);
            var c = a.get("view").getInfoWindow().getContent(),
                d = $("\x3ca/\x3e").text("Directions").attr("href", "#").addClass("action").addClass("directions"),
                e = $("\x3ca/\x3e").text("Zoom here").attr("href",
                    "#").addClass("action").addClass("zoomhere"),
                f = $("\x3ca/\x3e").text("Street view").attr("href", "#").addClass("action").addClass("streetview");
            d.click(function() {
                a.showDirections();
                return !1
            });
            e.click(function() {
                a.get("view").getMap().setOptions({
                    center: b.getLocation(),
                    zoom: 4
                })
            });
            f.click(function() {
                var c = a.get("view").getMap().getStreetView();
                c.setPosition(b.getLocation());
                c.setVisible(!0)
            });
            $(c).append(d).append(e).append(f)
        }
    };
    storeLocator.Panel.prototype.hideDirections = function() {
        this.directionsVisible_ = !1;
        this.directionsPanel_.fadeOut();
        this.featureFilter_.fadeIn();
        this.storeList_.fadeIn();
        this.directionsRenderer_.setMap(null)
    };
    storeLocator.Panel.prototype.showDirections = function() {
        var a = this.get("selectedStore");
        this.featureFilter_.fadeOut();
        this.storeList_.fadeOut();
        this.directionsPanel_.find(".directions-to").val(a.getDetails().title);
        this.directionsPanel_.fadeIn();
        this.renderDirections_();
        this.directionsVisible_ = !0
    };
    storeLocator.Panel.prototype.renderDirections_ = function() {
        var a = this;
        if (this.directionsFrom_ && this.directionsTo_) {
            var b = this.directionsPanel_.find(".rendered-directions").empty();
            this.directionsService_.route({
                origin: this.directionsFrom_,
                destination: this.directionsTo_.getLocation(),
                travelMode: google.maps.DirectionsTravelMode.DRIVING
            }, function(c, d) {
                if (d == google.maps.DirectionsStatus.OK) {
                    var e = a.directionsRenderer_;
                    e.setPanel(b[0]);
                    e.setMap(a.get("view").getMap());
                    e.setDirections(c)
                }
            })
        }
    };
    storeLocator.Panel.prototype.featureFilter_changed = function() {
        this.listenForStoresUpdate_()
    };
    storeLocator.PanelOptions = function() {};
    storeLocator.StaticDataFeed = function() {
        this.stores_ = []
    };
    storeLocator.StaticDataFeed = storeLocator.StaticDataFeed;
    storeLocator.StaticDataFeed.prototype.setStores = function(a) {
        this.stores_ = a;
        this.firstCallback_ ? this.firstCallback_() : delete this.firstCallback_
    };
    storeLocator.StaticDataFeed.prototype.getStores = function(a, b, c) {
        if (this.stores_.length) {
            for (var d = [], e = 0, f; f = this.stores_[e]; e++) f.hasAllFeatures(b) && d.push(f);
            this.sortByDistance_(a.getCenter(), d);
            c(d)
        } else {
            var g = this;
            this.firstCallback_ = function() {
                g.getStores(a, b, c)
            }
        }
    };
    storeLocator.StaticDataFeed.prototype.sortByDistance_ = function(a, b) {
        b.sort(function(b, d) {
            return b.distanceTo(a) - d.distanceTo(a)
        })
    };
    /*
     
       Latitude/longitude spherical geodesy formulae & scripts
       (c) Chris Veness 2002-2010
       www.movable-type.co.uk/scripts/latlong.html
     */
    storeLocator.Store = function(a, b, c, d, e) {
        this.id_ = a;
        this.location_ = b;
        this.features_ = c || storeLocator.FeatureSet.NONE;
        this.props_ = d || {};
        this.locName = e;
    };
    storeLocator.Store = storeLocator.Store;
    storeLocator.Store.prototype.setMarker = function(a) {
        this.marker_ = a;
        google.maps.event.trigger(this, "marker_changed", a)
    };
    storeLocator.Store.prototype.getMarker = function() {
        return this.marker_
    };
    storeLocator.Store.prototype.getId = function() {
        return this.id_
    };
    storeLocator.Store.prototype.getLocation = function() {
        return this.location_
    };
    storeLocator.Store.prototype.getFeatures = function() {
        return this.features_
    };
    storeLocator.Store.prototype.hasFeature = function(a) {
        return this.features_.contains(a)
    };
    storeLocator.Store.prototype.hasAllFeatures = function(a) {
        if (!a) return !0;
        a = a.asList();
        for (var b = 0, c = a.length; b < c; b++)
            if (!this.hasFeature(a[b])) return !1;
        return !0
    };
    storeLocator.Store.prototype.getDetails = function() {
        return this.props_
    };
    storeLocator.Store.prototype.generateFieldsHTML_ = function(a) {
        for (var b = [], c = 0, d = a.length; c < d; c++) {
            var e = a[c];
            this.props_[e] && (b.push('\x3cdiv class\x3d"'), b.push(e), b.push('"\x3e'), b.push(this.props_[e]), b.push("\x3c/div\x3e"))
        }
        return b.join("")
    };
    storeLocator.Store.prototype.generateFeaturesHTML_ = function() {
        var a = [];
        a.push('\x3cul class\x3d"features"\x3e');
        for (var b = this.features_.asList(), c = 0, d; d = b[c]; c++) a.push("\x3cli\x3e"), a.push(d.getDisplayName()), a.push("\x3c/li\x3e");
        a.push("\x3c/ul\x3e");
        return a.join("")
    };
    storeLocator.Store.prototype.getInfoWindowContent = function() {
        if (!this.content_) {
            var a = ['\x3cdiv class\x3d"store"\x3e'];
            a.push(this.generateFieldsHTML_(["title", "address", "phone", "misc", "web"]));
            a.push(this.generateFeaturesHTML_());
            a.push("\x3c/div\x3e");
            this.content_ = a.join("")
        }
        return this.content_
    };
    storeLocator.Store.prototype.getInfoPanelContent = function() {
        return this.getInfoWindowContent()
    };
    storeLocator.Store.infoPanelCache_ = {};
    storeLocator.Store.prototype.getInfoPanelItem = function() {
        var a = storeLocator.Store.infoPanelCache_,
            b = this.getId();
        if (!a[b]) {
            var c = this.getInfoPanelContent();
            a[b] = $('\x3cli class\x3d"store" id\x3d"store-' + this.getId() + '"\x3e' + c + "\x3c/li\x3e")[0]
        }
        return a[b]
    };
    storeLocator.Store.prototype.distanceTo = function(a) {
        var b = this.getLocation(),
            c = storeLocator.toRad_(b.lat()),
            d = storeLocator.toRad_(b.lng()),
            b = storeLocator.toRad_(a.lat()),
            e = storeLocator.toRad_(a.lng());
        a = b - c;
        d = e - d;
        c = Math.sin(a / 2) * Math.sin(a / 2) + Math.cos(c) * Math.cos(b) * Math.sin(d / 2) * Math.sin(d / 2);
        return 12742 * Math.atan2(Math.sqrt(c), Math.sqrt(1 - c))
    };
    storeLocator.DataFeed = function() {};
    storeLocator.DataFeed = storeLocator.DataFeed;
    storeLocator.DataFeed.prototype.getStores = function(a, b, c) {};
    storeLocator.View = function(a, b, c) {
        this.map_ = a;
        this.data_ = b;
        this.settings_ = $.extend({
            updateOnPan: !0,
            geolocation: !0,
            features: new storeLocator.FeatureSet
        }, c);
        this.init_();
        google.maps.event.trigger(this, "load");
        this.set("featureFilter", new storeLocator.FeatureSet)
    };
    storeLocator.View = storeLocator.View;
    storeLocator.View.prototype = new google.maps.MVCObject;
    storeLocator.View.prototype.geolocate_ = function() {
        var a = this;
        window.navigator && navigator.geolocation && navigator.geolocation.getCurrentPosition(function(b) {
            b = new google.maps.LatLng(b.coords.latitude, b.coords.longitude);
            a.getMap().setCenter(b);
            a.getMap().setZoom(6); // default zoom if location is enabled
            google.maps.event.trigger(a, "load")
        }, void 0, {
            maximumAge: 6E4,
            timeout: 1E4
        })
    };
    storeLocator.View.prototype.init_ = function() {
        this.settings_.geolocation && this.geolocate_();
        this.markerCache_ = {};
        this.infoWindow_ = new google.maps.InfoWindow;
        var a = this,
            b = this.getMap();
        this.set("updateOnPan", this.settings_.updateOnPan);
        google.maps.event.addListener(this.infoWindow_, "closeclick", function() {
            a.highlight(null)
        });
        google.maps.event.addListener(b, "click", function() {
            a.highlight(null);
            a.infoWindow_.close()
        })
    };
    storeLocator.View.prototype.updateOnPan_changed = function() {
        this.updateOnPanListener_ && google.maps.event.removeListener(this.updateOnPanListener_);
        if (this.get("updateOnPan") && this.getMap()) {
            var a = this,
                b = this.getMap();
            this.updateOnPanListener_ = google.maps.event.addListener(b, "idle", function() {
                a.refreshView()
            })
        }
    };
    storeLocator.View.prototype.addStoreToMap = function(a) {
        var b = this.getMarker(a);
        a.setMarker(b);
        var c = this;
        b.clickListener_ = google.maps.event.addListener(b, "click", function() {
            c.highlight(a, !1)
        });
        b.getMap() != this.getMap() && b.setMap(this.getMap())
    };
    storeLocator.View.prototype.createMarker = function(a) {
        a = {
            position: a.getLocation()
        };
        var b = this.settings_.markerIcon;
        b && (a.icon = b);
        return new google.maps.Marker(a)
    };
    storeLocator.View.prototype.getMarker = function(a) {
        var b = this.markerCache_,
            c = a.getId();
        b[c] || (b[c] = this.createMarker(a));
        return b[c]
    };
    storeLocator.View.prototype.getInfoWindow = function(a) {
        if (!a) return this.infoWindow_;
        a = $(a.getInfoWindowContent());
        this.infoWindow_.setContent(a[0]);
        return this.infoWindow_
    };
    storeLocator.View.prototype.getFeatures = function() {
        return this.settings_.features
    };
    storeLocator.View.prototype.getFeatureById = function(a) {
        if (!this.featureById_) {
            this.featureById_ = {};
            for (var b = 0, c; c = this.settings_.features[b]; b++) this.featureById_[c.getId()] = c
        }
        return this.featureById_[a]
    };
    storeLocator.View.prototype.featureFilter_changed = function() {
        google.maps.event.trigger(this, "featureFilter_changed", this.get("featureFilter"));
        this.get("stores") && this.clearMarkers()
    };
    storeLocator.View.prototype.clearMarkers = function() {
        for (var a in this.markerCache_) {
            this.markerCache_[a].setMap(null);
            var b = this.markerCache_[a].clickListener_;
            b && google.maps.event.removeListener(b)
        }
    };
    storeLocator.View.prototype.refreshView = function() {
        var a = this;
        this.data_.getStores(this.getMap().getBounds(), this.get("featureFilter"), function(b) {
            var c = a.get("stores");
            if (c)
                for (var d = 0, e = c.length; d < e; d++) google.maps.event.removeListener(c[d].getMarker().clickListener_);
            a.set("stores", b)
        })
    };
    storeLocator.View.prototype.stores_changed = function() {
        for (var a = this.get("stores"), b = 0, c; c = a[b]; b++) this.addStoreToMap(c)
    };
    storeLocator.View.prototype.getMap = function() {
        return this.map_
    };
    storeLocator.View.prototype.highlight = function(a, b) {
        var c = this.getInfoWindow(a);
        a ? (c = this.getInfoWindow(a), a.getMarker() ? c.open(this.getMap(), a.getMarker()) : (c.setPosition(a.getLocation()), c.open(this.getMap())), b && this.getMap().panTo(a.getLocation()), this.getMap().getStreetView().getVisible() && this.getMap().getStreetView().setPosition(a.getLocation())) : c.close();
        this.set("selectedStore", a)
    };
    storeLocator.View.prototype.selectedStore_changed = function() {
        google.maps.event.trigger(this, "selectedStore_changed", this.get("selectedStore"))
    };
    storeLocator.ViewOptions = function() {};
})(jQuery);
/*Info bubble */
! function() {
    var t, e = void 0;

    function o(t) {
        this.extend(o, google.maps.OverlayView), this.b = [], this.d = null, this.g = 100, this.m = !1, (t = t || {}).backgroundColor == e && (t.backgroundColor = this.z), t.borderColor == e && (t.borderColor = this.A), t.borderRadius == e && (t.borderRadius = this.B), t.borderWidth == e && (t.borderWidth = this.C), t.padding == e && (t.padding = this.F), t.arrowPosition == e && (t.arrowPosition = this.u), t.disableAutoPan == e && (t.disableAutoPan = !1), t.disableAnimation == e && (t.disableAnimation = !1), t.minWidth == e && (t.minWidth = this.D), t.shadowStyle == e && (t.shadowStyle = this.G), t.arrowSize == e && (t.arrowSize = this.v), t.arrowStyle == e && (t.arrowStyle = this.w), i(this), this.setValues(t)
    }

    function i(t) {
        var e = t.c = document.createElement("DIV");
        e.style.position = "absolute", e.style.zIndex = t.g, (t.i = document.createElement("DIV")).style.position = "relative";
        var o = t.l = document.createElement("IMG");
        o.style.position = "absolute", o.style.width = a(12), o.style.height = a(12), o.style.border = 0, o.style.zIndex = t.g + 1, o.style.cursor = "pointer", o.src = "https://www.google.com/intl/en_us/mapfiles/close.gif", google.maps.event.addDomListener(o, "click", function() {
            t.close(), google.maps.event.trigger(t, "closeclick")
        });
        var i = t.e = document.createElement("DIV");
        i.style.overflowX = "hidden", i.style.overflowY = "hidden", i.style.cursor = "default", i.style.clear = "both", i.style.position = "relative";
        var r = t.j = document.createElement("DIV");
        i.appendChild(r), (r = t.L = document.createElement("DIV")).style.position = "relative";
        var n = t.n = document.createElement("DIV"),
            p = t.k = document.createElement("DIV"),
            h = s(t);
        n.style.position = p.style.position = "absolute", n.style.left = p.style.left = "50%", n.style.height = p.style.height = "0", n.style.width = p.style.width = "0", n.style.marginLeft = a(-h), n.style.borderWidth = a(h), n.style.borderBottomWidth = 0, (h = t.a = document.createElement("DIV")).style.position = "absolute", e.style.display = h.style.display = "none", e.appendChild(t.i), e.appendChild(o), e.appendChild(i), r.appendChild(n), r.appendChild(p), e.appendChild(r), (e = document.createElement("style")).setAttribute("type", "text/css"), t.h = "_ibani_" + Math.round(1e4 * Math.random()), e.textContent = "." + t.h + "{-webkit-animation-name:" + t.h + ";-webkit-animation-duration:0.5s;-webkit-animation-iteration-count:1;}@-webkit-keyframes " + t.h + " {from {-webkit-transform: scale(0)}50% {-webkit-transform: scale(1.2)}90% {-webkit-transform: scale(0.95)}to {-webkit-transform: scale(1)}}", document.getElementsByTagName("head")[0].appendChild(e)
    }

    function s(t) {
        return parseInt(t.get("arrowSize"), 10) || 0
    }

    function r(t) {
        return parseInt(t.get("borderRadius"), 10) || 0
    }

    function n(t) {
        return parseInt(t.get("borderWidth"), 10) || 0
    }

    function p(t) {
        return parseInt(t.get("padding"), 10) || 0
    }

    function a(t) {
        return t ? t + "px" : t
    }

    function h(t) {
        t = t.replace(/^\s*([\S\s]*)\b\s*$/, "$1");
        var e = document.createElement("DIV");
        if (e.innerHTML = t, 1 == e.childNodes.length) return e.removeChild(e.firstChild);
        for (t = document.createDocumentFragment(); e.firstChild;) t.appendChild(e.firstChild);
        return t
    }

    function d(t) {
        if (t.j) {
            if (function(t) {
                    if (t)
                        for (var e; e = t.firstChild;) t.removeChild(e)
                }(t.j), o = t.getContent()) {
                "string" == typeof o && (o = h(o)), t.j.appendChild(o);
                for (var e, o = t.j.getElementsByTagName("IMG"), i = 0; e = o[i]; i++) google.maps.event.addDomListener(e, "load", function() {
                    var e = !t.get("disableAutoPan");
                    f(t), e && (0 == t.b.length || 0 == t.d.index) && t.o()
                });
                google.maps.event.trigger(t, "domready")
            }
            f(t)
        }
    }

    function l(t) {
        if (t.b && t.b.length) {
            for (var e, o = 0; e = t.b[o]; o++) y(t, e.f);
            t.d.style.zIndex = t.g, o = n(t), e = p(t) / 2, t.d.style.borderBottomWidth = 0, t.d.style.paddingBottom = a(e + o)
        }
    }

    function y(t, o) {
        var i = t.get("backgroundColor"),
            s = t.get("borderColor"),
            h = r(t),
            d = n(t),
            l = p(t),
            y = a(-Math.max(l, h)),
            c = (h = a(h), t.g);
        o.index && (c -= o.index);
        var g;
        i = {
            cssFloat: "left",
            position: "relative",
            cursor: "pointer",
            backgroundColor: i,
            border: a(d) + " solid " + s,
            padding: a(l / 2) + " " + a(l),
            marginRight: y,
            whiteSpace: "nowrap",
            borderRadiusTopLeft: h,
            MozBorderRadiusTopleft: h,
            webkitBorderTopLeftRadius: h,
            borderRadiusTopRight: h,
            MozBorderRadiusTopright: h,
            webkitBorderTopRightRadius: h,
            zIndex: c,
            display: "inline"
        };
        for (g in i) o.style[g] = i[g];
        (g = t.get("tabClassName")) != e && (o.className += " " + g)
    }

    function c(t, e) {
        if (e) {
            var o = p(t) / 2,
                i = n(t);
            if (t.d) {
                var s = t.d;
                s.style.zIndex = t.g - s.index, s.style.paddingBottom = a(o), s.style.borderBottomWidth = a(i)
            }
            e.style.zIndex = t.g, e.style.borderBottomWidth = 0, e.style.marginBottomWidth = "-10px", e.style.paddingBottom = a(o + i), t.setContent(t.b[e.index].content), d(t), t.d = e, f(t)
        } else t.setContent(""), d(t)
    }

    function g(t, e, o) {
        var i = document.createElement("DIV");
        return i.style.display = "inline", i.style.position = "absolute", i.style.visibility = "hidden", "string" == typeof t ? i.innerHTML = t : i.appendChild(t.cloneNode(!0)), document.body.appendChild(i), t = new google.maps.Size(i.offsetWidth, i.offsetHeight), e && t.width > e && (i.style.width = a(e), t = new google.maps.Size(i.offsetWidth, i.offsetHeight)), o && t.height > o && (i.style.height = a(o), t = new google.maps.Size(i.offsetWidth, i.offsetHeight)), document.body.removeChild(i), delete i, t
    }

    function f(t) {
        if (d = t.get("map")) {
            var e = p(t);
            n(t), r(t);
            var o = s(t),
                i = 2 * o,
                d = (l = d.getDiv()).offsetWidth - i,
                l = l.offsetHeight - i - u(t),
                y = (i = 0, t.get("minWidth") || 0),
                c = t.get("minHeight") || 0,
                f = t.get("maxWidth") || 0,
                m = t.get("maxHeight") || 0,
                b = (f = Math.min(d, f), m = Math.min(l, m), 0);
            if (t.b.length)
                for (var w, v = 0; w = t.b[v]; v++) {
                    var C = g(w.f, f, m);
                    w = g(w.content, f, m), y < C.width && (y = C.width), b += C.width, c < C.height && (c = C.height), C.height > i && (i = C.height), y < w.width && (y = w.width), c < w.height && (c = w.height)
                } else "string" == typeof(v = t.get("content")) && (v = h(v)), v && (y < (w = g(v, f, m)).width && (y = w.width), c < w.height && (c = w.height));
            f && (y = Math.min(y, f)), m && (c = Math.min(c, m)), (y = Math.max(y, b)) == b && (y += 2 * e), (y = Math.max(y, 2 * o)) > d && (y = d), c > l && (c = l - i), t.i && (t.t = i, t.i.style.width = a(b)), t.e.style.width = a(y), t.e.style.height = a(c)
        }
        r(t), e = n(t), d = 2, t.b.length && t.t && (d += t.t), o = 2 + e, (l = t.e) && l.clientHeight < l.scrollHeight && (o += 15), t.l.style.right = a(o), t.l.style.top = a(d + e), t.draw()
    }

    function u(t) {
        return t.get("anchor") && (t = t.get("anchorPoint")) ? -1 * t.y : 0
    }
    window.InfoBubble = o, (t = o.prototype).v = 15, t.w = 0, t.G = 1, t.D = 50, t.u = 50, t.F = 10, t.C = 1, t.A = "#ccc", t.B = 10, t.z = "#fff", t.extend = function(t, e) {
        return function(t) {
            for (var e in t.prototype) this.prototype[e] = t.prototype[e];
            return this
        }.apply(t, [e])
    }, t.ca = function(t) {
        this.set("backgroundClassName", t)
    }, o.prototype.setBackgroundClassName = o.prototype.ca, o.prototype.M = function() {
        this.j.className = this.get("backgroundClassName")
    }, o.prototype.backgroundClassName_changed = o.prototype.M, o.prototype.oa = function(t) {
        this.set("tabClassName", t)
    }, o.prototype.setTabClassName = o.prototype.oa, o.prototype.ra = function() {
        l(this)
    }, o.prototype.tabClassName_changed = o.prototype.ra, o.prototype.ba = function(t) {
        this.set("arrowStyle", t)
    }, o.prototype.setArrowStyle = o.prototype.ba, o.prototype.K = function() {
        this.p()
    }, o.prototype.arrowStyle_changed = o.prototype.K, o.prototype.aa = function(t) {
        this.set("arrowSize", t)
    }, o.prototype.setArrowSize = o.prototype.aa, o.prototype.p = function() {
        this.r()
    }, o.prototype.arrowSize_changed = o.prototype.p, o.prototype.$ = function(t) {
        this.set("arrowPosition", t)
    }, o.prototype.setArrowPosition = o.prototype.$, o.prototype.J = function() {
        this.n.style.left = this.k.style.left = (parseInt(this.get("arrowPosition"), 10) || 0) + "%", f(this)
    }, o.prototype.arrowPosition_changed = o.prototype.J, o.prototype.setZIndex = function(t) {
        this.set("zIndex", t)
    }, o.prototype.setZIndex = o.prototype.setZIndex, o.prototype.getZIndex = function() {
        return parseInt(this.get("zIndex"), 10) || this.g
    }, o.prototype.ta = function() {
        var t = this.getZIndex();
        this.c.style.zIndex = this.g = t, this.l.style.zIndex = t + 1
    }, o.prototype.zIndex_changed = o.prototype.ta, o.prototype.ma = function(t) {
        this.set("shadowStyle", t)
    }, o.prototype.setShadowStyle = o.prototype.ma, o.prototype.pa = function() {
        var t = "",
            e = "",
            o = "";
        switch (parseInt(this.get("shadowStyle"), 10) || 0) {
            case 0:
                t = "none";
                break;
            case 1:
                e = "40px 15px 10px rgba(33,33,33,0.3)", o = "transparent";
                break;
            case 2:
                e = "0 0 2px rgba(33,33,33,0.3)", o = "rgba(33,33,33,0.35)"
        }
        this.a.style.boxShadow = this.a.style.webkitBoxShadow = this.a.style.MozBoxShadow = e, this.a.style.backgroundColor = o, this.m && (this.a.style.display = t, this.draw())
    }, o.prototype.shadowStyle_changed = o.prototype.pa, o.prototype.qa = function() {
        this.set("hideCloseButton", !1)
    }, o.prototype.showCloseButton = o.prototype.qa, o.prototype.P = function() {
        this.set("hideCloseButton", !0)
    }, o.prototype.hideCloseButton = o.prototype.P, o.prototype.Q = function() {
        this.l.style.display = this.get("hideCloseButton") ? "none" : ""
    }, o.prototype.hideCloseButton_changed = o.prototype.Q, o.prototype.da = function(t) {
        t && this.set("backgroundColor", t)
    }, o.prototype.setBackgroundColor = o.prototype.da, o.prototype.N = function() {
        var t = this.get("backgroundColor");
        this.e.style.backgroundColor = t, this.k.style.borderColor = t + " transparent transparent", l(this)
    }, o.prototype.backgroundColor_changed = o.prototype.N, o.prototype.ea = function(t) {
        t && this.set("borderColor", t)
    }, o.prototype.setBorderColor = o.prototype.ea, o.prototype.O = function() {
        var t = this.get("borderColor"),
            e = this.e,
            o = this.n;
        e.style.borderColor = t, o.style.borderColor = t + " transparent transparent", e.style.borderStyle = o.style.borderStyle = this.k.style.borderStyle = "solid", l(this)
    }, o.prototype.borderColor_changed = o.prototype.O, o.prototype.fa = function(t) {
        this.set("borderRadius", t)
    }, o.prototype.setBorderRadius = o.prototype.fa, o.prototype.q = function() {
        var t = r(this),
            e = n(this);
        this.e.style.borderRadius = this.e.style.MozBorderRadius = this.e.style.webkitBorderRadius = this.a.style.borderRadius = this.a.style.MozBorderRadius = this.a.style.webkitBorderRadius = a(t), this.i.style.paddingLeft = this.i.style.paddingRight = a(t + e), f(this)
    }, o.prototype.borderRadius_changed = o.prototype.q, o.prototype.ga = function(t) {
        this.set("borderWidth", t)
    }, o.prototype.setBorderWidth = o.prototype.ga, o.prototype.r = function() {
        var t = n(this);
        this.e.style.borderWidth = a(t), this.i.style.top = a(t);
        t = n(this);
        var e = s(this),
            o = parseInt(this.get("arrowStyle"), 10) || 0,
            i = a(e),
            r = a(Math.max(0, e - t)),
            p = this.n,
            h = this.k;
        this.L.style.marginTop = a(-t), p.style.borderTopWidth = i, h.style.borderTopWidth = r, 0 == o || 1 == o ? (p.style.borderLeftWidth = i, h.style.borderLeftWidth = r) : p.style.borderLeftWidth = h.style.borderLeftWidth = 0, 0 == o || 2 == o ? (p.style.borderRightWidth = i, h.style.borderRightWidth = r) : p.style.borderRightWidth = h.style.borderRightWidth = 0, 2 > o ? (p.style.marginLeft = a(-e), h.style.marginLeft = a(-(e - t))) : p.style.marginLeft = h.style.marginLeft = 0, p.style.display = 0 == t ? "none" : "", l(this), this.q(), f(this)
    }, o.prototype.borderWidth_changed = o.prototype.r, o.prototype.la = function(t) {
        this.set("padding", t)
    }, o.prototype.setPadding = o.prototype.la, o.prototype.X = function() {
        this.e.style.padding = a(p(this)), l(this), f(this)
    }, o.prototype.padding_changed = o.prototype.X, o.prototype.onAdd = function() {
        this.c || i(this),
            function(t) {
                var e = "mousedown,mousemove,mouseover,mouseout,mouseup,mousewheel,DOMMouseScroll,touchstart,touchend,touchmove,dblclick,contextmenu,click".split(","),
                    o = t.c;
                t.s = [];
                for (var i, s = 0; i = e[s]; s++) t.s.push(google.maps.event.addDomListener(o, i, function(t) {
                    t.cancelBubble = !0, t.stopPropagation && t.stopPropagation()
                }))
            }(this);
        var t = this.getPanes();
        t && (t.floatPane.appendChild(this.c), t.floatShadow.appendChild(this.a))
    }, o.prototype.onAdd = o.prototype.onAdd, o.prototype.draw = function() {
        if (n = this.getProjection()) {
            var t = this.get("position");
            if (t) {
                var e = 0;
                this.d && (e = this.d.offsetHeight);
                var o = u(this),
                    i = s(this),
                    r = (r = parseInt(this.get("arrowPosition"), 10) || 0) / 100,
                    n = n.fromLatLngToDivPixel(t);
                if (t = this.e.offsetWidth) {
                    var p = n.y - (this.c.offsetHeight + i);
                    o && (p -= o);
                    var h = n.x - t * r;
                    switch (this.c.style.top = a(p), this.c.style.left = a(h), parseInt(this.get("shadowStyle"), 10)) {
                        case 1:
                            this.a.style.top = a(p + e - 1), this.a.style.left = a(h), this.a.style.width = a(t), this.a.style.height = a(this.e.offsetHeight - i);
                            break;
                        case 2:
                            t *= .8, this.a.style.top = a(o ? n.y : n.y + i), this.a.style.left = a(n.x - t * r), this.a.style.width = a(t), this.a.style.height = a(2)
                    }
                }
            } else this.close()
        }
    }, o.prototype.draw = o.prototype.draw, o.prototype.onRemove = function() {
        this.c && this.c.parentNode && this.c.parentNode.removeChild(this.c), this.a && this.a.parentNode && this.a.parentNode.removeChild(this.a);
        for (var t, e = 0; t = this.s[e]; e++) google.maps.event.removeListener(t)
    }, o.prototype.onRemove = o.prototype.onRemove, o.prototype.R = function() {
        return this.m
    }, o.prototype.isOpen = o.prototype.R, o.prototype.close = function() {
        this.c && (this.c.style.display = "none", this.c.className = this.c.className.replace(this.h, "")), this.a && (this.a.style.display = "none", this.a.className = this.a.className.replace(this.h, "")), this.m = !1
    }, o.prototype.close = o.prototype.close, o.prototype.open = function(t, e) {
        var o = this;
        window.setTimeout(function() {
            ! function(t, e, o) {
                d(t), e && t.setMap(e), o && (t.set("anchor", o), t.bindTo("anchorPoint", o), t.bindTo("position", o)), t.c.style.display = t.a.style.display = "", t.get("disableAnimation") || (t.c.className += " " + t.h, t.a.className += " " + t.h), f(t), t.m = !0, t.get("disableAutoPan") || window.setTimeout(function() {
                    t.o()
                }, 200)
            }(o, t, e)
        }, 0)
    }, o.prototype.open = o.prototype.open, o.prototype.setPosition = function(t) {
        t && this.set("position", t)
    }, o.prototype.setPosition = o.prototype.setPosition, o.prototype.getPosition = function() {
        return this.get("position")
    }, o.prototype.getPosition = o.prototype.getPosition, o.prototype.Y = function() {
        this.draw()
    }, o.prototype.position_changed = o.prototype.Y, o.prototype.o = function() {
        var t = this.getProjection();
        if (t && this.c) {
            var e = this.c.offsetHeight + u(this),
                o = this.get("map"),
                i = o.getDiv().offsetHeight,
                s = this.getPosition(),
                r = t.fromLatLngToContainerPixel(o.getCenter());
            s = t.fromLatLngToContainerPixel(s), e = r.y - e, i = i - r.y, r = 0;
            0 > e && (r = (-1 * e + i) / 2), s.y -= r, s = t.fromContainerPixelToLatLng(s), o.getCenter() != s && o.panTo(s)
        }
    }, o.prototype.panToView = o.prototype.o, o.prototype.setContent = function(t) {
        this.set("content", t)
    }, o.prototype.setContent = o.prototype.setContent, o.prototype.getContent = function() {
        return this.get("content")
    }, o.prototype.getContent = o.prototype.getContent, o.prototype.na = function(t) {
        (t = this.b[t - 1]) && c(this, t.f)
    }, o.prototype.setTabActive = o.prototype.na, o.prototype.ia = function(t) {
        this.set("maxWidth", t)
    }, o.prototype.setMaxWidth = o.prototype.ia, o.prototype.U = function() {
        f(this)
    }, o.prototype.maxWidth_changed = o.prototype.U, o.prototype.ha = function(t) {
        this.set("maxHeight", t)
    }, o.prototype.setMaxHeight = o.prototype.ha, o.prototype.T = function() {
        f(this)
    }, o.prototype.maxHeight_changed = o.prototype.T, o.prototype.ka = function(t) {
        this.set("minWidth", t)
    }, o.prototype.setMinWidth = o.prototype.ka, o.prototype.W = function() {
        f(this)
    }, o.prototype.minWidth_changed = o.prototype.W, o.prototype.ja = function(t) {
        this.set("minHeight", t)
    }, o.prototype.setMinHeight = o.prototype.ja, o.prototype.V = function() {
        f(this)
    }, o.prototype.minHeight_changed = o.prototype.V, o.prototype.H = function(t, e) {
        var o = document.createElement("DIV");
        o.innerHTML = t, y(this, o),
            function(t, e) {
                e.S = google.maps.event.addDomListener(e, "click", function() {
                    c(t, this)
                })
            }(this, o), this.i.appendChild(o), this.b.push({
                label: t,
                content: e,
                f: o
            }), o.index = this.b.length - 1, o.style.zIndex = this.g - o.index, this.d || c(this, o), o.className = o.className + " " + this.h, f(this)
    }, o.prototype.addTab = o.prototype.H, o.prototype.sa = function(t, o, i) {
        this.b.length && !(0 > t || t >= this.b.length) && (t = this.b[t], o != e && (t.f.innerHTML = t.label = o), i != e && (t.content = i), this.d == t.f && (this.setContent(t.content), d(this)), f(this))
    }, o.prototype.updateTab = o.prototype.sa, o.prototype.Z = function(t) {
        if (this.b.length && !(0 > t || t >= this.b.length)) {
            var o = this.b[t];
            o.f.parentNode.removeChild(o.f), google.maps.event.removeListener(o.f.S), this.b.splice(t, 1), delete o;
            for (var i, s = 0; i = this.b[s]; s++) i.f.index = s;
            o.f == this.d && (this.d = this.b[t] ? this.b[t].f : this.b[t - 1] ? this.b[t - 1].f : e, c(this, this.d)), f(this)
        }
    }, o.prototype.removeTab = o.prototype.Z, o.prototype.I = function() {
        this.draw()
    }, o.prototype.anchorPoint_changed = o.prototype.I
}();